import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

const routes = [
  {path: '/', component: () => import('../components/home')},
  {path: '/home', component: () => import('../components/home')},
  {
    path: '/login',
    component: () => import('../components/login')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../components/admin/index'),
    children: [
      {
        path: 'home',
        component: () => import('../components/admin/home')
      },
      {path: 'product/category-edit', component: () => import('../components/admin/product/category-edit')},
      {path: 'product/category-list', component: () => import('../components/admin/product/category-list')},
      {path: 'template/index', component: () => import('../components/admin/template/Index')},
      {path: 'article/list', component: () => import('../components/admin/article/list')},
      {path: 'article/edit', component: () => import('../components/admin/article/edit')},
      {path: 'article/category-list', component: () => import('../components/admin/article/category-list')},
      {path: 'system/setting', component: () => import('../components/admin/system/setting')},
      {path: 'ad/position-list', component: () => import('../components/admin/ad/position-list')},
      {path: 'ad/list', component: () => import('../components/admin/ad/list')},
      {path: 'setting/menu', component: () => import('../components/admin/setting/menu')},
      {path: 'nav/index', component: () => import('../components/admin/nav/index')},
      {path: 'setting/menu-permission', component: () => import('../components/admin/setting/menu-permission')},
      {path: 'setting/backup', component: () => import('../components/admin/setting/backup')},
      {path: 'permission/role-list', component: () => import('../components/admin/permission/role-list')},
      {path: 'guestbook/list', component: () => import('../components/admin/guestbook/list')}
    ]
  },
  {path: '/admin/multiple', component: () => import('../components/admin/multiple')},
  {path: '/admin/site/add', component: () => import('../components/admin/site/add')},
  {path: '/admin/login', component: () => import('../components/admin/login')},
  {path: '/admin/reg', component: () => import('../components/admin/reg')},
  {path: '/admin/find-password', component: () => import('../components/admin/find-password')}
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  var access_token = Cookies.get('access_token')
  if (access_token != 'null' && access_token != undefined && access_token != '') {  // 通过vuex state获取当前的token是否存在
    next()
  } else {
    if (to.query.access_token && to.query.user_id) {
      Cookies.set('access_token', to.query.access_token)
      Cookies.set('user_id', to.query.user_id)
      next()
    } else {

      let screenWidth = window.screen.width
      if (screenWidth > 800) {
        //location.href = Vue.prototype.loginDomain + '/jz/#/admin/login?redirectUrl=' + encodeURIComponent(location.href)
        if (to.path == '/admin/login' || to.path == '/admin/reg' || to.path == '/admin/find-password') {
          next();
        }else {
          //电脑端
          next({path:'/admin/login'})
        }
      } else {
        //location.href = Vue.prototype.loginDomain + '/jz/#/login?redirectUrl=' + encodeURIComponent(location.href)
        if (to.path == '/mobile/login' || to.path == '/mobile/reg' || to.path == '/mobile/find-password') {
          next();
        }else {
          //手机端
          next({path:'/mobile/login?redirectUrl='+encodeURIComponent(location.href)})
        }
      }
    }
  }
})

export default router
